// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__1bGGA","gridContainer":"Entity_gridContainer__1CBvQ","icon":"Entity_icon__2o1ou","content":"Entity_content__yz-Wu","value":"Entity_value__2CR83"};